import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import AccountDeletion from "@/pages/AccountDeletion";
import CsaePolicy from "@/pages/CsaePolicy";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppDashboard from "@/pages/AppDashboard";

function Loader() {
  return (
    <div className="min-h-screen bg-reveal-black flex items-center justify-center text-reveal-cream/60 font-body">
      Loading…
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/landing" replace />} />
      <Route path="/landing" element={<Landing />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/account-deletion" element={<AccountDeletion />} />
      <Route path="/csae-policy" element={<CsaePolicy />} />
      <Route path="/law-enforcement" element={<LegalPage page="law" />} />
      <Route path="/acceptable-use" element={<LegalPage page="aup" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Navigate to="/landing" replace />} />
      <Route path="/app" element={<ProtectedRoute><AppDashboard /></ProtectedRoute>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
